import { useState } from "react";
import type { ProductData } from "@/mocks/products";

interface Props {
  product: ProductData;
}

export default function ScreenshotsGallery({ product }: Props) {
  const [activeIdx, setActiveIdx] = useState(0);

  return (
    <section className="py-10 md:py-14 bg-graphite-850/30">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="mb-8 md:mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2">
              Screenshots
            </h2>
            <p className="text-base text-silver-400">
              See {product.name.replace("StackMap ", "")} in action.
            </p>
          </div>

          <div className="space-y-4">
            <div className="rounded-xl overflow-hidden border border-graphite-700 bg-black">
              <img
                alt={product.screenshots[activeIdx].label}
                className="w-full h-56 sm:h-72 md:h-96 object-cover object-top"
                src={product.screenshots[activeIdx].image}
              />
            </div>

            <div className="flex flex-wrap gap-2">
              {product.screenshots.map((ss, idx) => (
                <button
                  key={ss.label}
                  onClick={() => setActiveIdx(idx)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                    idx === activeIdx
                      ? "bg-emerald-accent text-white"
                      : "bg-graphite-800 text-silver-300 hover:text-white hover:bg-graphite-700"
                  }`}
                >
                  {ss.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}